export const getIsPropertyInput = input => {
  if ('property' in input) {
    return true;
  }
  return false;
};